const DotLoader = () => {
  return (
    <div className="flex items-center space-x-1">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="w-2 h-2 bg-gray-600 rounded-full animate-pulse"
        />
      ))}
    </div>
  );
};

export default DotLoader;
